import { Col, Row } from "react-grid-system";
import { useQuery } from "react-query";
import { deleteUser, getUser, UserType } from "../../../api/admin/user";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { SFormFooter } from "../../../styles/ChangePassword";
import { Button } from "../../Button";
import { QueryLoader } from "../../Loader";
import DeleteIcon from "../../../assets/img/icons/delete-green.svg";
import { useState } from "react";

type DeleteUserProps = { userId: number; refetchUsers: () => void; closeModal: () => void };

export const DeleteUser = (props: DeleteUserProps) => {
	const { userId, refetchUsers, closeModal } = props;
	const { axiosPrivate } = useAxiosPrivate();

	const { isLoading, isError, error, data } = useQuery<UserType>(["user", userId], () => getUser(axiosPrivate, userId));

	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleDelete = async () => {
		setIsSubmitting(true);
		const res = await deleteUser({ axiosPrivate, userId });
		if (res?.status === 204) {
			refetchUsers();
			closeModal();
		}
		setIsSubmitting(false);
	};

	if (isLoading) {
		return <QueryLoader />;
	}

	if (isError) {
		console.error(error);
		return <>Something went wrong...</>;
	}

	if (!data) {
		return (
			<>
				<Row>
					<Col>
						<h3>User not exists</h3>
					</Col>
				</Row>
				<Row>
					<Col>
						<SFormFooter>
							<Button onClick={() => closeModal()}>Close</Button>
						</SFormFooter>
					</Col>
				</Row>
			</>
		);
	}

	return (
		<>
			<Row>
				<Col>
					<h3>
						Delete {data?.firstName} {data?.lastName}
					</h3>
				</Col>
			</Row>
			<Row style={{ marginTop: "1rem" }}>
				<Col>
					<p>Are you sure you want to delete this user?</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<SFormFooter>
						<Button onClick={() => closeModal()}>Cancel</Button>
						<Button type="submit" onClick={() => handleDelete()} icon={DeleteIcon} disabled={isSubmitting}>
							Delete
						</Button>
					</SFormFooter>
				</Col>
			</Row>
		</>
	);
};
